/*=========================================================================================
  File Name: moduleExpenseSetting.js
  Description: ExpenseSetting Module
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

import state from './moduleExpenseState.js';
import mutations from './moduleExpenseMutation';
import actions from './moduleExpenseAction';
import getters from './moduleExpenseGetter';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
